document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.thb-localization-forms .select').forEach((wrap) => {
    const select = wrap.querySelector('select');
    if (!select) return;
    wrap.style.cursor = 'pointer';
    wrap.addEventListener('click', (e) => {
      if (e.target === select) return;
      if (typeof select.showPicker === 'function') {
        try { select.showPicker(); } catch (err) { select.focus(); }
      } else {
        select.focus();
      }
    });
  });
});